import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../../../components/button';

type SheetStatus = 'pending' | 'success' | null;

type Props = {
  status: SheetStatus;
  onClose: () => void;
};

const PartnershipAgreementBottomSheet = ({status, onClose}: Props) => {
  const isOpen = Boolean(status);

  if (!status) return null;

  const isPending = status === 'pending';

  return (
    <BottomSheet
      open={isOpen}
      onDismiss={onClose}
      blocking
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col gap-2 px-4 py-3">
        <SpanIcon
          className="absolute text-2xl text-gray-600 top-4 left-5 icon-nameClose-remove"
          onClick={onClose}
        />

        <SpanIcon className="text-3xl text-center icon-nameCheck-circle text-farm-shop-500" />
        <h4 className="text-lg font-medium text-center text-zinc-800">
          {isPending ? 'درخواست امضای قرارداد' : 'در انتظار تایید قرارداد'}
        </h4>

        <p className="mb-2 leading-6 text-md text-zinc-500">
          {isPending
            ? 'جهت ادامه فرایند و امضای قرارداد، نیازمند ساخت امضای دیجیتال هستید. برای ساخت امضای دیجیتال، فرایند را ادامه دهید.'
            : 'درخواست شما برای امضای  قرارداد مشارکت در فروش ثبت شده و در حال بررسی است. نتیجه بررسی به شما اطلاع رسانی می‌شود.'}
        </p>

        <Button onClick={onClose}>
          {isPending ? 'تایید و ادامه' : 'متوجه شدم'}
        </Button>
      </div>
    </BottomSheet>
  );
};

export default PartnershipAgreementBottomSheet;
